import { useEffect, useState } from "react";
import { toast } from "sonner";
import { API, api } from "../lib/api";

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
      <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z" />
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
    </svg>
  );
}

function MetaIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path fill="#1877F2" d="M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.69 4.53-4.69 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.96.93-1.96 1.89v2.26h3.33l-.53 3.49h-2.8V24C19.61 23.1 24 18.1 24 12.07z" /></svg>
  );
}

function rememberNext(next) {
  if (next && next.startsWith("/")) sessionStorage.setItem("bpj_next", next);
}

export default function SocialButtons({ next }) {
  const [providers, setProviders] = useState({ google: true, facebook: false });
  useEffect(() => {
    api.get("/auth/providers").then((r) => setProviders(r.data || {})).catch(() => {});
    const h = window.location.hash || "";
    if (h.includes("login_error=")) {
      toast.error("Sign-in was cancelled or failed. Please try again.");
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
    }
  }, []);

  const google = () => {
    rememberNext(next);
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  const facebook = () => {
    if (!providers.facebook) { toast("Facebook sign-in is being set up — please use Google or email for now."); return; }
    rememberNext(next);
    window.location.href = `${API}/auth/facebook/start?origin=${encodeURIComponent(window.location.origin)}`;
  };

  const btn = "w-full h-12 border border-[var(--line)] bg-white hover:border-[var(--ink)] flex items-center justify-center gap-3 font-semibold text-[var(--ink)] transition-colors";
  return (
    <div className="space-y-3" data-testid="social-buttons">
      <button type="button" onClick={google} className={btn} data-testid="google-login-btn"><GoogleIcon /> Continue with Google</button>
      <button type="button" onClick={facebook} className={`${btn} ${providers.facebook ? "" : "opacity-60"}`} data-testid="facebook-login-btn"><MetaIcon /> Continue with Facebook</button>
      <div className="flex items-center gap-4 pt-3"><span className="h-px flex-1 bg-[var(--line)]" /><span className="eyebrow">or with email</span><span className="h-px flex-1 bg-[var(--line)]" /></div>
    </div>
  );
}
